import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

import { getBackgroundColor, getBorderColor } from '../../utils/colors';

const getSize = (size) => {
  switch (size) {
    case 'small':
      return 30;
    case 'medium':
      return 40;
    case 'large':
      return 60;
    default:
      return 40;
  }
};

const StyledButton = withStyles((theme) => ({
  root: {
    height: (props) => `${getSize(props.size)}px !important`,
    width: (props) => `${getSize(props.size)}px !important`,
    minWidth: '30px !important',
    borderRadius: '8px',
    textTransform: 'capitalize',
    fontSize: '10px',
    border: (props) => `1px solid ${getBorderColor(props.disabled ? 'grey' : props.color)}`,
    background: (props) => getBackgroundColor(props.disabled ? 'grey' : props.color),
    cursor: (props) => props.disabled ? 'default' : 'pointer',
    '&:hover': {
      background: (props) => getBackgroundColor(props.disabled ? 'grey' : props.color)
    }
  }
}))(MuiButton);

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '12px',
    padding: '4px 8px',
    borderRadius: 8,
    cursor: 'pointer'
  }
}));

const ActionIconButton = ({
  onClick,
  disabled,
  color, // ['green', 'orange', 'blue', 'red]
  loading,
  children,
  tooltip,
  className,
  size = 'medium', // ['small', 'medium', 'large']
}) => {
  const classes = useStyles();
  const colorClassName = disabled ? 'disabled' : (color || 'default');
  const buttonClassName = `action-icon-button action-icon-button--${colorClassName}${className ? ` ${className}` : ''}`;

  if (tooltip) {
    return (
      <Tooltip
        title={tooltip}
        aria-label={`action_button_tooltip`}
        classes={{ tooltip: classes.tooltip }}
      >
        <StyledButton
          className={buttonClassName}
          onClick={onClick}
          disabled={disabled}
          color={disabled? 'grey' : color}
          size={size}
        >
          <div className='d-flex direction-column space-between'>
            { loading ? <CircularProgress size={24} /> : children }
          </div>
        </StyledButton>
      </Tooltip>
    );
  }

  return (
    <StyledButton
      className={buttonClassName}
      onClick={onClick}
      disabled={disabled}
      color={disabled? 'grey' : color}
      size={size}
    >
      <div className='d-flex direction-column space-between'>
        { loading ? <CircularProgress size={24} /> : children }
      </div>
    </StyledButton>
  );
};

export default ActionIconButton;
